import { useState, useEffect } from "react";
import Config from "../../Config";


import InputDate from "../../helpers/InputDate";
import InputTime from "../../helpers/InputTime";
import InputText from "../../helpers/InputText";
import InputSearchKid from "../../helpers/InputSearchKid";
import InputCombo from "../../helpers/InputCombo";


function HourRefresh(props)
{

    
    const [view, setView] = useState('btn');

    const [errTab, setErrTab] = useState([]);  //z info od serwera..
    const [row, setRow] = useState({
        dzien_od:  "",   
        dzien_do: ""
    });



    const valChangeListener = (filedName, val, correct, msg) => {

        console.log("valChangeListener: " + filedName + " " + val + ", correct: " + correct + ", msg: " + msg);     
        setRow( {...row, [filedName]:val,  [filedName+"_valid"]:correct } );         
    }  

    const goNextNew = () => {
        console.log("goNext");
        saveData();
    }

    const valChecker = (fields) => {

        var allValid = true;

              
        Object.entries(fields).forEach(function(entry) {

            var xKey    = entry[0];
            var xValue  = entry[1];

            var xValidName = xKey + "_valid";

            if(fields[xValidName] == false)
            {
                allValid = false;
                console.log("Error field: " + xKey);
            }
            
          });
        
          return allValid;

    }


  


    const saveData = (e) => {


        if(e.target.innerHTML == '...') return;


       
 


        if( row.dzien_od.length < 3)
        {
            props.mainView.showDialog(props.userData.dic.dlg_notice_wrong , props.userData.dic.dlg_gocorrect  ,  "ok"  ,null); 
            return;
        }

        if( row.dzien_do.length < 3)
            {
                props.mainView.showDialog(props.userData.dic.dlg_notice_wrong , props.userData.dic.dlg_gocorrect  ,  "ok"  ,null); 
                return;
            }

    

         e.target.innerHTML = "...";
 
 
        props.mainView.setProgress(-2);

        var req =  row;


        fetch( Config.url + '/rest_v1_kids,hour_refresh', {
            method: 'POST', 
            body: JSON.stringify(req), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                '_p_dziecko_id_': props.userData.p_dziecko_id,
                '_sec_key_': Config.genXKey() ,
            }
         })
         .then(res => res.json() )
         .then(res => { 

                    changeView();

                    props.mainView.setProgress(-1);        
                    if(res._sys_ == undefined)
                    {
                        props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                    }else
                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                    {
                        props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                    }else    
                    {
                       props.mainView.showDialog( "Sukces",  "Operacja zakończona sukcesem" , "ok" , null);    
                       props.onSuccess();                      
                    }
         } )
         .catch(err => {          
                    props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                    props.mainView.setProgress(-1);
         });
                   

         return false;

    }



    const changeView = () => {

    setRow({
        dzien_od: '',
        dzien_do: ''
    });
        
        if(view == 'btn') {setView("dlg"); }  else setView('btn');
    }     


 
 


    var dlg_view =  (

            <div className="dlg_window dlg_type_x shadowx">

                    <div className="dlg_title">
                            Odświeżenie godzin wg. wejść i wyjść
                    </div>


                    <div className="dlg_content_x">


                                    <div className="form_tab">

                                      

                                        <div className="form_control">
                                            <div className="fieldName">Od dnia (włącznie)</div>
                                            <InputDate   userData={props.userData} value={row.dzien_od} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="dzien_od" placeholder={"Dzień od: "} className=' w150 ' req='1' firstUp="1" />
                                        </div>
 

                                        <div className="form_control">
                                            <div className="fieldName">Do dnia (włącznie)</div>
                                            <InputDate   userData={props.userData} value={row.dzien_do} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="dzien_do" placeholder={"Dzień do: "} className=' w150 ' req='1' firstUp="1" />
                                        </div>


                                        <div className="form_split"></div>

                                        <div className="form_control">                                            
                                            <div className="btn" onClick={saveData}>odśwież</div>
                                            &nbsp; &nbsp;
                                            <div className="btn" onClick={changeView}>anuluj</div>
                                        </div>

                                        <br/>&nbsp;
                                        </div>

                    </div>

                
            </div>
    );

    if(view == 'btn') dlg_view = null;


    return  <div className="inline_block">
                <div className="btn"    onClick={changeView} >odśwież wg. wejść i wyjść </div> 
                {dlg_view} 
           </div>
}


export default HourRefresh;